<template>
  <avs-card>
    <template v-slot:title>
      <v-card-title class="pl-0">{{ $t("Configuration espace") }}</v-card-title>
    </template>
    <template v-slot:content>
      <v-container>
        <v-form
          :readonly="!isEditable"
          ref="form"
        >
          <v-text-field
            v-model="shopLocation.name"
            :disabled="!isEditable"
            :rules="rules.name"
            :label="$t('Nom')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="shopLocation.description"
            :disabled="!isEditable"
            :rules="rules.description"
            :label="$t('Adresse')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>

          <v-text-field
            v-model="shopLocation.price"
            :disabled="!isEditable"
            :rules="rules.price"
            :label="$t('Tarif')"
            outlined
            dense
          ></v-text-field>
          <v-col class="d-flex justify-end gap-4">
            <avs-saveButton
              v-if="!loading"
              @click="save"
              :disabled="!isEditable"
            />
            <avs-button
              v-else
              icon
              color="secondary"
              class="spin-loading"
              :iconI="loading ? 'mdi-loading spin' : ''"
              label
              fab
              small
            />
            <avs-cancelButton @click="cancel" />
          </v-col>
        </v-form>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
import { mkSpace } from "@/utils/datamodels"
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { SpaceService } from "@/services"
import { required, max64, isNumber } from "@/utils/validator"
import _ from "lodash"

export default {
  name: "SpaceEditor",
  props: {
    hasUniqueName: {
      type: Function,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object
    }
  },
  computed: {
    shopLocation: {
      get() {
        return _.cloneDeep(this.value || this.getDefaultValue())
      }
    },
    project() {
      return this.$store.state.app.project
    }
  },
  data() {
    return {
      defaultItems: [],
      shop: mkSpace(),
      loading: false,
      rules: {
        description: [],
        name: [required, max64],
        price: [isNumber]
      },
      users: [],
      cities: [],
      municipalities: []
    }
  },
  methods: {
    getDefaultValue() {
      return this.shop
    },
    cancel() {
      this.$emit("cancel")
    },
    async performSave(data) {
      if (data.id > 0) {
        return SpaceService.put(data)
      } else {
        return SpaceService.post(this.project.id, data)
      }
    },
    async save() {
      this.loading = true

      if (this.$refs.form.validate()) {
        try {
          const response = await this.performSave(this.shopLocation)
          this.$emit("input", response)
          this.$emit("success", this.$t("Le site a été sauvegardé avec succès."))
        } catch (error) {
          const message = error?.response?.data?.detail || this.$t("Une erreur est survenue.")
          this.$emit("error", message)
        } finally {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    }
  }
}
</script>

<style>
.ck.ck-editor__main > .ck-editor__editable {
  height: 200px;
}
.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by {
  display: none !important;
}
.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.ck-editor__editable {
  color: rgba(0, 0, 0, 0.87) !important;
}

.spin-loading {
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
